/**
 * OAuth 相关常量定义
 * 用于 Google 和 Apple 登录流程
 */

/**
 * 授权登录的类型
 * login - 登录
 * new_register - 新用户
 * bind - 游客账户绑定谷歌、苹果等账户进行注册
 */
export const OAUTH_ACTION_TYPE = {
  LOGIN: 'login',
  REGISTER: 'new_register',
  BIND: 'bind'
}

/**
 * OAuth 提供商名称
 */
export const OAUTH_PROVIDERS = {
  GOOGLE: 'Google',
  APPLE: 'Apple',
}

/**
 * 谷歌授权方式
 */
export const GOOGLE_AUTH_TYPES = {
  ID_TOKEN: 'id_token', // One Tap 方式，返回 ID Token (JWT)
  AUTH_TOKEN: 'auth_token', // OAuth 2.0 Token 方式，返回 access_token
  AUTH_CODE: 'auth_code', // OAuth 2.0 Authorization Code 方式，返回 authorization code
}

/**
 * OAuth SessionStorage Keys
 * 用于在回调页面和 SPA 之间传递参数
 *
 * ⚠️ 注意：这些 key 也会通过 Vite define 注入到静态 HTML 文件中
 * 修改这些值时，需要重新构建项目
 */
export const OAUTH_REDIRECT_STORAGE_KEYS = 'REDIRECT'

/**
 * OAuth 回调路由路径
 */
export const OAUTH_CALLBACK_ROUTES = {
  GOOGLE: '/oauth/google-callback',
  APPLE: '/oauth/apple-callback',
}
